export const blogs = [
  {
    slug: "scalable-web-architecture",
    title: "How to Build Scalable Web Architecture",
    excerpt:
      "Learn proven strategies and technologies to design scalable, secure web applications.",
    content: `
      <p>Building scalable web architecture is essential for modern businesses...</p>
      <h2>Why Scalability Matters</h2>
      <p>Scalability ensures long-term growth...</p>
    `,
    tags: ["Web Development", "Scalability", "Architecture"],
    category: "Engineering",
    author: "Oglitz Engineering Team",
    date: "2025-01-10",
    readingTime: "6 min read",
  },
  {
    slug: "cloud-devops-best-practices",
    title: "Cloud & DevOps Best Practices for Startups",
    excerpt:
      "Discover how startups can leverage cloud and DevOps for faster growth.",
    content: `<p>Cloud and DevOps enable faster deployments...</p>`,
    tags: ["Cloud", "DevOps", "Startups"],
    category: "Cloud",
    author: "Oglitz Cloud Team",
    date: "2025-01-05",
    readingTime: "5 min read",
  },
];
